import React, { useState, useEffect } from "react";
import "./CalendarComponent.css";
import { RiArrowLeftDoubleLine, RiArrowRightDoubleFill } from "react-icons/ri";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ShowCalendarBatch = ({axios,constant,user,checkUserLogin,selectedCourseOption,studentBatchAssign,studentEnrollBatch,freeUserStatus}) => {
  
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [days, setDays] = useState([]);
  const [calendarData, setCalendarData] = useState([]);

  const getUpcomingBatchData = () => {
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_calendar.php?fun=upcomingBatchData`,
      headers: { 'Auth-Id': user.auth_id },
      data: {
        currentMonth: currentMonth,
        selectedCourse:selectedCourseOption,
      }
    })
      .then((response) => {
        checkUserLogin(response);
       
        if (response.data.data.status === 1) {
          setCalendarData(response.data.data.upcoming_batch_list);
        }
      })
      .catch((error) => {
        console.error('Error fetching class data:', error);
      });
  };

  useEffect(() => {
        getUpcomingBatchData(currentMonth); 
  }, [currentMonth]);


  useEffect(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();
    const tempDays = Array.from({ length: daysInMonth }, (_, i) => ({
      date: new Date(year, month, i + 1),
      message: "",
      backgroundColor: "",
      color: "",
    }));

    calendarData.forEach((event) => {
      const eventDate = new Date(event.date);
      if (eventDate.getFullYear() === year && eventDate.getMonth() === month) {
        const dayIndex = eventDate.getDate() - 1;
        if (tempDays[dayIndex]) {
          tempDays[dayIndex].message = event.message;
           tempDays[dayIndex].batch_id = event.batch_id;
          tempDays[dayIndex].backgroundColor = event.backgroundColor;
          tempDays[dayIndex].color = event.color;
          tempDays[dayIndex].type = event.type;
        }
      }
    });

    const daysWithPadding = [...Array(firstDay).fill(null), ...tempDays];
    setDays(daysWithPadding);
  }, [currentMonth,calendarData]);

  const handlePrevMonth = () => {
    
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1)
    );
  };

  const handleNextMonth = () => {
    
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1)
    );
  };

  const [isClicked,setIsClicked] = useState(false);

  const handleEnrollNow = (day) => {
    const confirmAction = window.confirm("Are you sure you want to Continue?");
    if (!confirmAction) return;

    if(freeUserStatus){
     setIsClicked(true);
     studentEnrollBatch(day);
    }else{
     setIsClicked(true);
     studentBatchAssign(day);
    }
  };

  return (
    <div className="calendar-container">
      <div className="calendar df fdc w100">
        <div className="calendar-nav bg3 pt12 pb12 fc1 v-center jcsb pl12 pr12 fs18 ls1 lh22">
          <button onClick={handlePrevMonth} className="fs24 fc1 cp v-center">
            <RiArrowLeftDoubleLine />
          </button>
          <div>
            {currentMonth.toLocaleString("default", { month: "long" })}{" "}
            {currentMonth.getFullYear()}
          </div>
          <button onClick={handleNextMonth} className="fs24 fc1 cp v-center">
            <RiArrowRightDoubleFill />
          </button>
        </div>
        <div className="calendar-header df fc1 fw5 fs14 ls2 bg8">
          <div>Sun</div>
          <div>Mon</div>
          <div>Tue</div>
          <div>Wed</div>
          <div>Thu</div>
          <div>Fri</div>
          <div>Sat</div>
        </div>
        <div className="calendar-body df fww">
          {days.map((day, index) => (
            <div
              key={index}
              className="calendar-day cp"
              style={{
                backgroundColor: day?.backgroundColor || "transparent",
                color: day?.color || "#000000",
              }}
              onClick={day?.message && day?.type !== "holiday" ? ()=>handleEnrollNow(day) : undefined}
            >
              {day && (
                <>
                  <div className="date fw6 mb4">{day.date.getDate()}</div>
                  <div
                    className={`message-inside lh18 fs12 ls1 pt8 ls2 fw6 ${day?.type === "holiday" ? "fw6" : ""}`}

                    style={{
                      color: day?.color || "#8b8f92",
                    }}
                  >
                    {day?.message}
                  </div>

                  {day?.message && day?.type !== "holiday" && (
                    <div className="box-center">
                     {!isClicked && freeUserStatus && (
                        <button className="mt8 cp enroll-now-btn">
                          Enroll Now
                        </button>
                      )}
                      {!isClicked && !freeUserStatus && (
                        <button className="mt8 cp enroll-now-btn">
                          Join Now
                        </button>
                      )}
                    </div>
                  )}
                  
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="calendar-messages mt16">
        <p className="fs14 fw6 ls1 lh16">Event List</p>
        {days.map(
          (day, index) =>
            day?.message && (
              <div
                key={index}
                className="message-item fc6 mb12 lh18 fs12 ls1 pt8"
                // style={{ color: day.color || "#8b8f92" }}
              >
                <p className="fw6 fs14">{day.date.toDateString()}:</p>{" "}
                {day.message}
              </div>
            )
        )}
      </div>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default ShowCalendarBatch;
